export default __webpack_public_path__ + "assets/c9e7ca00d15a51940af3eb96e58ed338.svg";